module.exports = __webpack_public_path__ + "img/animated-animals.76f60279.svg";